<template>
    <VTextarea :value="value" label="Impression Tracker Secure" outlined @input="emitModelValue" />
</template>
<script>
export default {
    name: 'ImpressionTrackerInput',
    props: {
        value: {
            type: String,
            required: false,
        },
    },
    setup(props, { emit }) {
        const emitModelValue = (newValue) => {
            emit('input', newValue);
        };

        return {
            emitModelValue,
        };
    },
};
</script>
